/**
 * SQL Notebook Feature Module
 *
 * Registers the notebook workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the notebook workspace component
registerWorkspaceComponent(
  'notebook',
  lazyWorkspaceTab(() => import('./components/NotebookTab').then((m) => ({ default: m.NotebookTab }))),
);

// Re-export components
